export const getBackendUrl = () => {
  const runtimeUrl = window.APP_CONFIG?.apiUrl;
  if (runtimeUrl !== undefined && runtimeUrl !== null) return runtimeUrl;
  return process.env.REACT_APP_BACKEND_URL || '';
};
